module.exports = __webpack_public_path__ + "img/zhongxuan.3d647846.png";